/**
 * Vocabulary of the capture grammar (docs/06 §2): the same rules read Spanish and Catalan words,
 * so both languages behave the same and a sentence can mix them. Accents are optional in what
 * the user types, so every pattern accepts the letter with and without its accent.
 */
/** Day names by ISO weekday (1 = Monday). */
export const WEEKDAYS = {
    1: ['lunes', 'dilluns'],
    2: ['martes', 'dimarts'],
    3: ['miércoles', 'miercoles', 'dimecres'],
    4: ['jueves', 'dijous'],
    5: ['viernes', 'divendres'],
    6: ['sábado', 'sabado', 'dissabte'],
    7: ['domingo', 'diumenge'],
};
/** Month names by number; Catalan months also appear with the elided article («d'octubre»). */
export const MONTHS = {
    1: ['enero', 'gener'],
    2: ['febrero', 'febrer'],
    3: ['marzo', 'març', 'marc'],
    4: ['abril'],
    5: ['mayo', 'maig'],
    6: ['junio', 'juny'],
    7: ['julio', 'juliol'],
    8: ['agosto', 'agost'],
    9: ['septiembre', 'setiembre', 'setembre'],
    10: ['octubre'],
    11: ['noviembre', 'novembre'],
    12: ['diciembre', 'desembre'],
};
/** Relative days: offset from today. */
export const RELATIVE_DAYS = [
    ['pasado mañana', 2],
    ['pasado manana', 2],
    ['demà passat', 2],
    ['dema passat', 2],
    ['hoy', 0],
    ['avui', 0],
    ['mañana', 1],
    ['manana', 1],
    ['demà', 1],
    ['dema', 1],
];
/** Small numbers written out, for «en tres días» / «d'aquí a dues setmanes». */
export const NUMBER_WORDS = {
    un: 1,
    una: 1,
    uno: 1,
    dos: 2,
    dues: 2,
    tres: 3,
    cuatro: 4,
    quatre: 4,
    cinco: 5,
    cinc: 5,
    seis: 6,
    sis: 6,
    siete: 7,
    set: 7,
    ocho: 8,
    vuit: 8,
    nueve: 9,
    nou: 9,
    diez: 10,
    deu: 10,
    quince: 15,
    quinze: 15,
};
/** Units of «en N …»: days, weeks, months. */
export const UNITS = {
    día: 'day',
    dia: 'day',
    días: 'day',
    dias: 'day',
    dies: 'day',
    semana: 'week',
    semanas: 'week',
    setmana: 'week',
    setmanes: 'week',
    mes: 'month',
    meses: 'month',
    mesos: 'month',
};
/** Markers that turn the date after them into a start date («desde el lunes»). */
export const START_MARKERS = ['a partir de', 'a partir', 'desde', 'des de', 'des'];
//# sourceMappingURL=vocabulary.js.map